/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactComponent as DashboardIcon } from '@assets/icons/dashboard.svg';
import { ReactComponent as HomeWorkIcon } from '@assets/icons/homework.svg';
import { ReactComponent as NotificationIcon } from '@assets/icons/notifications.svg';
import { ReactComponent as SettingsIcon } from '@assets/icons/settings.svg';
import { ReactComponent as LeaderboardIcon } from '@assets/icons/leaderboard.svg';
import { ReactComponent as NoticeboardIcon } from '@assets/icons/noticeboard.svg';
import { ReactComponent as AnnouncementIcon } from '@assets/icons/megaphone.svg';
import { ReactComponent as CalendarIcon } from '@assets/icons/calendar.svg';

import {
  DASHBOARD,
  HOMEWORKS,
  LEADERBOARD,
  NOTIFICATIONS,
  NOTICEBOARD,
  SETTINGS,
  CHAT,
  CALENDAR
} from './routes';

export const STUDENT_MENU_ITEMS = [
  {
    id: 1,
    Icon: DashboardIcon,
    label: 'Dashboard',
    route: DASHBOARD.DASHBOARD
  },
  {
    id: 2,
    Icon: HomeWorkIcon,
    label: 'Homeworks',
    route: HOMEWORKS.HOMEWORKSLIST
  },
  {
    id: 3,
    Icon: NotificationIcon,
    label: 'Notifications',
    route: NOTIFICATIONS.NOTIFICATIONS
  },
  {
    id: 8,
    Icon: CalendarIcon,
    label: 'Calendar',
    route: CALENDAR.CALENDAR
  },
  {
    id: 4,
    Icon: LeaderboardIcon,
    label: 'Leaderboard',
    route: LEADERBOARD.LEADERBOARD
  },
  {
    id: 5,
    Icon: AnnouncementIcon,
    label: 'Announcement',
    route: NOTICEBOARD.NOTICEBOARD
  },
  {
    id: 6,
    Icon: NoticeboardIcon,
    label: 'Chat',
    route: CHAT.CHAT
  },
  {
    id: 7,
    Icon: SettingsIcon,
    label: 'Settings',
    route: SETTINGS.SETTINGS
  }
];

export const PARENT_MENU_ITEMS = [
  {
    id: 1,
    Icon: DashboardIcon,
    label: 'Dashboard',
    route: DASHBOARD.DASHBOARD
  },
  {
    id: 2,
    Icon: HomeWorkIcon,
    label: 'Homeworks',
    route: HOMEWORKS.HOMEWORKSLIST
  },
  {
    id: 3,
    Icon: NotificationIcon,
    label: 'Notifications',
    route: NOTIFICATIONS.NOTIFICATIONS
  },
  {
    id: 7,
    Icon: CalendarIcon,
    label: 'Calendar',
    route: CALENDAR.CALENDAR
  },
  {
    id: 4,
    Icon: AnnouncementIcon,
    label: 'Announcement',
    route: NOTICEBOARD.NOTICEBOARD
  },
  {
    id: 5,
    Icon: NoticeboardIcon,
    label: 'Chat',
    route: CHAT.CHAT
  },
  {
    id: 6,
    Icon: SettingsIcon,
    label: 'Settings',
    route: SETTINGS.SETTINGS
  }
];
